import { useTranslation } from "i18n";
import { useMemo } from "react";

export const useGetTranslationContent = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      castingNotes: {
        viewNotesLabel: t("common:label.profile.viewNotesLable"),
        printLabel: t("common:label.profile.printLabel"),
        moreButtonLabel: t("common:label.profile.moreButtonLabel"),
        emailLabel: t("common:label.profile.emailLabel"),
        newShortlistOption: t("common:label.profile.newShortlistOption"),
        newShortlistLabel: t("common:label.profile.newShortlistLabel"),
        shortlistRequired: t("common:label.profile.shortlistRequired"),
        saveShortlist: t("common:label.profile.saveShortlist"),
        shortlistPlaceholder: t("common:label.profile.shortlistPlaceholder"),
        performerAddedToast: t("common:label.profile.performerAddedToast"),
        shortlistSearchPlaceholder: t(
          "common:label.profile.shortlistSearchPlaceholder"
        ),
        actionsButtonLabel: t("common:label.profile.actionsButtonLabel"),
        cancelShortlist: t("common:label.profile.cancelShortlist"),
        shortlistLabel: t("common:label.profile.shortlistLabel"),
        addToShortlistLabel: t("common:label.profile.addToShortlistLabel"),
        saveNotesButtonLabel: t("common:label.profile.saveNotesButtonLabel"),
        addToShortlistHeader: t("common:label.profile.addToShortlistLabel"),
        shortlistNameRequired: t("common:label.profile.shortlistNameRequired"),
      },
      emailForm: {
        emailFormRecipientsMaxCount: t(
          "common:label.profile.emailFormRecipientsMaxCount"
        ),
        emailFormSenderNameRequired: t(
          "common:label.profile.emailFormSenderNameRequired"
        ),
        emailFormMessageLabel: t("common:label.profile.emailFormMessageLabel"),
        emailFormSenderEmailLabel: t(
          "common:label.profile.emailFormSenderEmailLabel"
        ),
        emailFormSenderNameMaxLength: t(
          "common:label.profile.emailFormSenderNameMaxLength"
        ),
        emailFormSenderNameLabel: t(
          "common:label.profile.emailFormSenderNameLabel"
        ),
        emailFormSubjectRequired: t(
          "common:label.profile.emailFormSubjectRequired"
        ),
        emailFormRecipientsLabel: t(
          "common:label.profile.emailFormRecipientsLabel"
        ),
        emailFormHeader: t("common:label.profile.emailFormHeader"),
        emailFormSenderEmailRequired: t(
          "common:label.profile.emailFormSenderEmailRequired"
        ),
        emailFormSubmitButton: t("common:label.profile.emailFormSubmitButton"),
        emailFormCancelButton: t("common:label.profile.cancelShortlist"),
        emailFormSenderEmailMaxLength: t(
          "common:label.profile.emailFormSenderEmailMaxLength"
        ),
        emailFormRecipientsSingleValid: t(
          "common:label.profile.emailFormRecipientsSingleValid"
        ),
        emailFormAdditionalText: t(
          "common:label.profile.emailFormAdditionalText"
        ),
        emailFormRecipientsSingleMaxLength: t(
          "common:label.profile.emailFormRecipientsSingleMaxLength"
        ),
        emailFormRecipientsRequired: t(
          "common:label.profile.emailFormRecipientsRequired"
        ),
        emailFormSubjectMaxLength: t(
          "common:label.profile.emailFormSubjectMaxLength"
        ),
        emailFormSubjectTemplate: t(
          "common:label.profile.emailFormSubjectTemplate"
        ),
        emailFormSenderEmailValidEmail: t(
          "common:label.profile.emailFormSenderEmailValidEmail"
        ),
        emailFormSubjectLabel: t("common:label.profile.emailFormSubjectLabel"),
      },
    }),
    [t]
  );
};
